import { Action, FilterType } from '../types'
import React from 'react'
import { Box, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { LeafTypes, NodeType } from 'shared/types/ingestion'

export function TypeChange({
  action,
  onActionChange,
  filterType,
}: {
  action?: Action
  onActionChange: (action?: Action, done?: boolean) => void
  filterType: FilterType
}) {
  const isNodeAction = filterType === FilterType.node
  const options = optionsForFilterType(filterType)
  const data = (action?.actionType === 'typeChange' && action.data) || {
    newType: '',
  }

  const onChange = (e: SelectChangeEvent) => {
    let newType: NodeType | LeafTypes
    if (filterType === FilterType.node) {
      newType = e.target.value as NodeType
    } else {
      newType = e.target.value as LeafTypes
    }
    onActionChange({ actionType: 'typeChange', data: { newType } }, true)
  }

  const nodeOrLeaf = isNodeAction ? 'Node' : 'Leaf'
  return (
    <Box>
      <Box>Changing To:</Box>
      <Select
        displayEmpty={true}
        value={data.newType ?? ''}
        onChange={onChange}
        renderValue={(v: unknown) =>
          v ? String(v) : `Select ${nodeOrLeaf} Type`
        }
      >
        {options.map(([name, value]) => {
          return (
            <MenuItem key={value} value={value}>
              {name}
            </MenuItem>
          )
        })}
      </Select>
    </Box>
  )
}

function optionsSort([n1]: [string, unknown], [n2]: [string, unknown]) {
  return n1.localeCompare(n2)
}

function optionsForFilterType(filterType: FilterType) {
  const isNodeAction = filterType === FilterType.node
  return Object.entries(isNodeAction ? NodeType : LeafTypes)
    .filter(([, value]) => {
      return !value.startsWith('reference') && !value.startsWith('weighted')
    })
    .sort(optionsSort)
}
